module.exports = __webpack_public_path__ + "9c8373819524cb1fea4937e4ac82f254.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/left_hand/burrito.png
// module id = 2372
// module chunks = 0